import * as actions from './actions'
// import * as getters from './getters'
// import * as mutations from './mutations'

const state = {
  cart: {

  }
}

export default {
  state,
  // getters,
  actions
  // mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cart/index.js